import ContactGroupService from "../../../shared/services/ContactGroupService";
import { db } from "../../../shared/plugins/firebase-app";

const contactGroupService = new ContactGroupService(db);
export default contactGroupService;
